var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.75 14.1665C29.75 24.0832 17 32.5832 17 32.5832C17 32.5832 4.25 24.0832 4.25 14.1665C4.25 10.785 5.5933 7.54198 7.98439 5.15089C10.3755 2.7598 13.6185 1.4165 17 1.4165C20.3815 1.4165 23.6245 2.7598 26.0156 5.15089C28.4067 7.54198 29.75 10.785 29.75 14.1665Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 18.4165C19.3472 18.4165 21.25 16.5137 21.25 14.1665C21.25 11.8193 19.3472 9.9165 17 9.9165C14.6528 9.9165 12.75 11.8193 12.75 14.1665C12.75 16.5137 14.6528 18.4165 17 18.4165Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.032add2354d9e1df2d48d9bd0d45a104.svg";
export { ForwardRef as ReactComponent };